import { ConditionCode } from '@/shared/api/protocol-ts/model/dto_report_condition_codes_pb';

// FDA-only condition codes that should NOT appear in non-FDA mode
export const FDA_ONLY_CONDITION_CODES: ConditionCode[] = [
  ConditionCode.FDA_Caries,
  ConditionCode.FDA_RestorativeImperfections,
  ConditionCode.FDA_Child_EndoTreated_CanalFilling,
  ConditionCode.FDA_Child_EndoTreated_PostAndCore,
];

// FDA 2.0 conditions list (WA-6322 spec, section 3).
// Conditions are bound to codes, not names: renamed conditions
// (Furcation, Calculus, DMF over 50%, ...) keep their existing codes;
// FDA-only diagnoses use the dedicated FDA_* codes.

// Tooth-like objects + diagnoses submitted in both modalities
const FDA_VERSION2_COMMON_CONDITION_CODES: ConditionCode[] = [
  ConditionCode.EndoTreated,
  ConditionCode.FDA_Child_EndoTreated_CanalFilling,
  ConditionCode.Child_EndoTreated_Obturation_ShortFilling,
  ConditionCode.Child_EndoTreated_Obturation_Overfilling,
  ConditionCode.CodeTooth,
  ConditionCode.Implant,
  ConditionCode.Missing,
  ConditionCode.RootFragment,
  ConditionCode.ToothGerm,
  ConditionCode.Pontic,
];

const FDA_VERSION2_2D_CONDITION_CODES: ConditionCode[] = [
  ...FDA_VERSION2_COMMON_CONDITION_CODES,
  ConditionCode.FDA_Caries,
  ConditionCode.FDA_RestorativeImperfections,
  ConditionCode.FDA_Child_EndoTreated_PostAndCore,
  ConditionCode.PeriapicalRadiolucency,
  ConditionCode.FurcationLesion,
  ConditionCode.DentalCalculus,
  ConditionCode.CrownDefectOver50pct,
  ConditionCode.OrthodonticAppliance,
  ConditionCode.PulpStone,
];

const FDA_VERSION2_3D_CONDITION_CODES: ConditionCode[] = [
  ...FDA_VERSION2_COMMON_CONDITION_CODES,
  ConditionCode.CariesSigns,
  ConditionCode.Child_EndoTreated_PostAndCore_CastPostAndCore,
  ConditionCode.Child_EndoTreated_Obturation_AdequateObturation,
  ConditionCode.Child_EndoTreated_Quality_AdequateDensity,
  ConditionCode.Child_EndoTreated_Obturation_MissedCanal,
  ConditionCode.Child_EndoTreated_Quality_VoidsPresentInTheRootFilling,
  ConditionCode.Filling,
  ConditionCode.Abfraction,
];

const FDA_VERSION2_COMMON_MASK_CONDITION_CODES: ConditionCode[] = [
  ConditionCode.FDA_Child_EndoTreated_CanalFilling,
];

const FDA_VERSION2_2D_MASK_CONDITION_CODES: ConditionCode[] = [
  ...FDA_VERSION2_COMMON_MASK_CONDITION_CODES,
  ConditionCode.Child_EndoTreated_Obturation_ShortFilling,
  ConditionCode.Child_EndoTreated_Obturation_Overfilling,
  ConditionCode.FDA_Caries,
  ConditionCode.FDA_RestorativeImperfections,
  ConditionCode.FDA_Child_EndoTreated_PostAndCore,
  ConditionCode.PeriapicalRadiolucency,
  ConditionCode.FurcationLesion,
  ConditionCode.DentalCalculus,
  ConditionCode.OrthodonticAppliance,
];

const FDA_VERSION2_3D_MASK_CONDITION_CODES: ConditionCode[] = [
  ...FDA_VERSION2_COMMON_MASK_CONDITION_CODES,
  ConditionCode.CariesSigns,
  ConditionCode.Filling,
  ConditionCode.Abfraction,
];

export const getFDAVersion2ConditionCodes = (is2DReport: boolean) =>
  is2DReport
    ? FDA_VERSION2_2D_CONDITION_CODES
    : FDA_VERSION2_3D_CONDITION_CODES;

export const getFDAVersion2MaskConditionCodes = (is2DReport: boolean) =>
  is2DReport
    ? FDA_VERSION2_2D_MASK_CONDITION_CODES
    : FDA_VERSION2_3D_MASK_CONDITION_CODES;

export const FDA_VERSION2_AUTODETECTED_ENDO_CHILD_CODES: ConditionCode[] = [
  ConditionCode.FDA_Child_EndoTreated_CanalFilling,
  ConditionCode.FDA_Child_EndoTreated_PostAndCore,
  ConditionCode.Child_EndoTreated_Obturation_ShortFilling,
  ConditionCode.Child_EndoTreated_Obturation_Overfilling,
  ConditionCode.Child_EndoTreated_PostAndCore_CastPostAndCore,
  ConditionCode.Child_EndoTreated_Obturation_AdequateObturation,
  ConditionCode.Child_EndoTreated_Quality_AdequateDensity,
  ConditionCode.Child_EndoTreated_Obturation_MissedCanal,
  ConditionCode.Child_EndoTreated_Quality_VoidsPresentInTheRootFilling,
];
